<template>
	<div id="modalImportImg" class="modal fade">
		<div class="modal-backdrop">
		<div class="modal-dialog modal-dialog-vertical-center modal-md" role="document">
			<div class="modal-content bd-0 tx-14">
				<PageLoading :show="loading" />
				<div class="modal-header pd-y-20 pd-x-25">
					<h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
						上传图片/搜索相关信息
						<span class="tx-danger tx-12 tx-normal">(以图搜图测试版)</span>
					</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close "@click="close">
						<span aria-hidden="true">×</span>
					</button>
				</div>
				<div class="modal-body pd-25 model-auto-h">
					<div class="row mg-x-0">
						<div class="mg-r-30">
							<a href="javascript:;" class="btn btn-success" @click="clickUpload">本地上传</a>
							<div class=" d-none" id="upload-iptimg">
							  <input
								@change="bannerBase64($event)"
								type="file"
								name="uploadFile"
								accept=".jpg,.png,.gif"
							  />
							</div>
						</div>
						<div class="col-md-9 pos-relative">
							<input type="text" class="form-control form-control-md pd-r-40" placeholder="粘贴图片网址" v-model="searchImgUrl" @keyup.enter="searchUrl"/>
							<i class="iconfont icon-sousuo pos-absolute tx-26 t-0 r-25" @click="searchUrl" style="cursor: pointer"></i>
						</div>
					</div>
					<div class="row mg-x-0 mg-t-30">
						<div
						  class="upload-drag"
						  @drop="drop($event)"
						  @dragenter="dragenter($event)"
						  @dragover="dragover($event)"
						>
						  <p class=" mg-b-10 pd-x-10 tx-gray-500 tx-26">或者将图片文件拖到此处</p>
						  <p class="mg-b-0 pd-x-10 tx-gray-500 tx-16 paste">或者截图后 Ctrl + V 粘贴图片</p>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" @click="close">关闭</button>
				</div>
			</div>
		</div>
		</div>
	</div>
</template>

<script>
import PageLoading from "./pageLoading";
export default{
	props:["open","load"],
	data(){
		return{
			loading: false,
			importImgInfo:{
				imgUrlBase64: "",
				ext: "",
				src: "",
			},
			searchImgUrl:""
		}
	},
	components: {
	  PageLoading,
	},
	watch:{
		load:function(){
			this.loading = this.load;
		},
		open: function() {
			this.loading = this.load;
			this.importImgInfo.imgUrlBase64 = "";
			this.importImgInfo.ext = "";
			this.importImgInfo.src = "";
			this.searchImgUrl = "";
		}
	},
	 mounted() {
	  //粘贴监听
	  window.addEventListener("paste", e => {
	    let [clipboardData, i, items, item, types] = [e.clipboardData, 0];
	    if (clipboardData) {
	      items = clipboardData.items;
	      if (!items) {
	        return;
	      }
	      item = items[0];
	      types = clipboardData.types || [];
	      for (; i < types.length; i++) {
	        if (types[i] === "Files") {
	          item = items[i];
	          break;
	        }
	      }
	      if (item && item.kind === "file" && item.type.match(/^image\//i)) {
	        this.imgReader(item);
	      }
	    }
	  });
	},
	methods:{
		close() {
		  this.$emit("close");
		},
		searchProByImgFn(base64,ext,imgUrl,src){
			console.log(1)
			this.loading = true;
			let imgInfo = {
				base64:base64,
				ext:ext,
				imgUrl:imgUrl,
				src:src
			};
			let searchFlag = true;
			this.$emit("searchProByImgFn",imgInfo,searchFlag);
		},
		searchUrl(){
			this.searchProByImgFn("","",this.searchImgUrl,"");
		},
		bannerBase64(event) {
			//图上传 base64
			let el = event.target;
			if (el.value) {
				let reader = new FileReader(),
					img = new Image(),
					ext = "";
				reader.onload = e => {
					img.src = e.target.result;
					let extArr = e.target.result.match(/data:image\/(.*);base64,.*/);
					ext = extArr[1];
				};
				img.onload = e => {
					base64Image({
						file: el,
						callback: rst => {
							let base64 = rst.split("base64,").pop();
							this.importImgInfo.imgUrlBase64 = base64;
							this.importImgInfo.ext = ext;
							this.importImgInfo.src = img.src;
							this.searchProByImgFn(this.importImgInfo.imgUrlBase64,this.importImgInfo.ext,"",this.importImgInfo.src);
						}
					});
				};
				reader.readAsDataURL(el.files[0]);
			}
		},
		clickUpload() {
			//上传图片点击
			document.querySelector("#upload-iptimg > input").click();
		},
		dragenter(el) {
			el.stopPropagation();
			el.preventDefault();
		},
		dragover(el) {
			el.stopPropagation();
			el.preventDefault();
		},
		drop(el) {
			el.stopPropagation();
			el.preventDefault();
			this.fileList(el.dataTransfer);
		},
		formatImg(src) {
			let vm = this;
			let img = new Image();
			let ext = "";
			let extArr = src.match(/data:image\/(.*);base64,.*/);
			ext = extArr[1];
			this.importImgInfo.ext = ext;
			this.importImgInfo.src = img.src = src;
			this.importImgInfo.imgUrlBase64 = src.split("base64,").pop();
			this.searchProByImgFn(this.importImgInfo.imgUrlBase64,this.importImgInfo.ext,"",this.importImgInfo.src);
		},
		imgReader(item) {
			let vm = this;
			let blob = item.getAsFile(),
		    reader = new FileReader(),
		    img = new Image();
			img.onload = function() {
				vm.formatImg(img.src);
			};
			reader.onload = function(e) {
				img.src = e.target.result;
			};
			reader.readAsDataURL(blob);
		},
		fileClick() {
			document.getElementById("upload_file").click();
		},
		fileChange(el) {
			if (!el.target.files[0].size) return;
			this.fileList(el.target);
			el.target.value = "";
		},
		fileList(fileList) {
			let files = fileList.files;
			for (let i = 0; i < files.length; i++) {
				//判断是否为文件夹
				if (files[i].type != "") {
					this.fileAdd(files[i]);
				} else {
				//文件夹处理
					this.folders(fileList.items[i]);
				}
			}
		},
		//文件夹处理
		folders(files) {
			let _this = this;
			//判断是否为原生file
			if (files.kind) {
				files = files.webkitGetAsEntry();
			}
			if (!files.createReader) return;
			files.createReader().readEntries(function(file) {
				for (let i = 0; i < file.length; i++) {
					if (file[i].isFile) {
						_this.foldersAdd(file[i]);
						break; // 暂只取1张
					} else {
						_this.folders(file[i]);
					}
				}
			});
		},
		foldersAdd(entry) {
			let _this = this;
			entry.file(function(file) {
				_this.fileAdd(file);
			});
		},
		fileAdd(file) {
			//判断是否为图片文件
			if (file.type.indexOf("image") == -1) {
				return;
			} else {
				let reader = new FileReader();
				let image = new Image();
				let _this = this;
				reader.readAsDataURL(file);
				reader.onload = function() {
					file.src = this.result;
					image.onload = function() {
						_this.formatImg(image.src);
					};
					image.src = file.src;
				};
			}
		},
	}
}
</script>

<style scoped="scoped">
.modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;
    outline: 0;
	width: 37.5rem;
}
.modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px;
    border-bottom: 1px solid #e9ecef;
}
.modal-header h6{
	margin: 0;
	color: #343a40;
}
.close {
    float: right;
    font-size: 1.3125rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}
.modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 25px;
}
.row {
    display: flex;
    flex-wrap: wrap;
    margin-right: 0;
    margin-left: 0;
}
button.close {
    padding: 0;
    background: 0 0;
    border: 0;
    -webkit-appearance: none;
}
.btn, .sp-container button {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: .65rem .75rem;
    font-size: .875rem;
    line-height: 1.25;
    border-radius: 3px;
    transition: all .15s ease-in-out;
	height: auto;
}
.btn-success {
    color: #fff;
    background-color: #23bf08;
    border-color: #23bf08;
}
.d-none {
    display: none!important;
}
.dataTables_filter input, .form-control {
    display: block;
    width: 100%;
    padding: .65rem .75rem;
    font-size: .875rem;
    line-height: 1.25;
    color: #495057;
    background-color: #fff;
    background-image: none;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 3px;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}
.mg-t-30 {
    margin-top: 30px;
}
.modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 15px;
    border-top: 1px solid #e9ecef;
}
.btn, .sp-container button {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    user-select: none;
    border: 1px solid transparent;
    padding: .65rem .75rem;
    font-size: .875rem;
    line-height: 1.25;
    border-radius: 3px;
    transition: all .15s ease-in-out;
}
.btn-secondary {
    color: #fff;
    background-color: #868e96;
    border-color: #868e96;
}
.tx-semibold {
    font-weight: 600;
}
.pd-y-12 {
    padding-top: 12px;
    padding-bottom: 12px;
}
.pd-x-25 {
    padding-left: 25px;
    padding-right: 25px;
}
.upload-drag {
  flex: 2;
  border: 1px #c1c1c1 dashed;
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 150px;
}
.upload-drag:active .paste {
  color: #333;
}
.tx-26 {
    font-size: 26px;
}
.tx-gray-500 {
    color: #adb5bd;
}
.pd-x-10 {
    padding-left: 10px;
    padding-right: 10px;
}
.mg-b-10 {
    margin-bottom: 10px;
}
.tx-16 {
    font-size: 16px;
}
.tx-gray-500 {
    color: #adb5bd;
}
.pd-x-10 {
    padding-left: 10px;
    padding-right: 10px;
}
.mg-b-0 {
    margin-bottom: 0;
}
.mg-r-30 {
    margin-right: 30px;
}
.col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
}
.pd-r-40 {
    padding-right: 50px;
	box-sizing: border-box;
}
.r-25 {
    right: 12px;
}
.t-0 {
    top: 0;
	color: #666;
}
.pos-absolute {
    position: absolute;
}
.pos-relative {
    position: relative;
}
</style>
